import { Table, TableHeader, TableRow } from '@/components/Grid'
import { FormSection } from '@/containers/forms/FormSection'
import { usePoleasImportContext } from '@/context/PoleasImportProvider'
import { useSidebar } from '@/context/SidebarContext'
import { Alert, Box, Button, Flex, Grid, Spinner, Stack, Tbody, Text, Thead } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { PoleasImportSections } from '../PoleasImport'
import { ImportPreviewRow } from './ImportPreviewRow'

export const ImportPreviewForm = () => {

  const {
    totalOfferCount,
    previewRows,
    previewCallInProgress,
    showCancelButton,
    showImportButton,
    importId,
    cancelImportInProgress,
    cancelImport,
    finishImport,
    finalImportInProgress,
    importedOfferCount
  } = usePoleasImportContext()

  const navigate = useNavigate()
  const { pageSections, setPageSections } = useSidebar()
  const currentSection = pageSections.find(x => x.id == PoleasImportSections.Preview)

  const updatePageSection = (sectionTitle: React.ReactNode, title?: string) => {
    if (currentSection) {
      currentSection.sectionTitle = sectionTitle
      currentSection.title = title ?? undefined
    }

    setPageSections([...pageSections])
  }

  const finalProgressMsg = `Importuji nabídku ${importedOfferCount + 1} z ${totalOfferCount}`

  const previewWithErrors = previewRows?.some(pr => pr.error) ?? false

  useEffect(() => {
    if (previewCallInProgress) {
      const baseMsg = 'Náhled importu'
      const msg = `Zpracování záznamu ${previewRows.length + 1} z ${totalOfferCount}`

      updatePageSection(
        (<Flex alignItems='center' justifyContent='space-between'>
          <Text sx={{ fontWeight: 'bold' }}>{msg}</Text>
          <Button colorScheme="red" onClick={() => cancelImportInProgress()}>Zastavit zpracování náhledu</Button>
        </Flex>)
        , `${currentSection?.index}. ${baseMsg}`
      )

    } else {
      updatePageSection('Náhled importu')
    }

  }, [previewCallInProgress, previewRows.length])

  const errors = (previewWithErrors &&
        <Alert colorScheme="red">
          <Stack>
            <Text fontWeight={'semibold'}>Import obsahuje chyby</Text>
            <Text>Buď zrušte import, opravte data v souboru a znovu naimportujte, nebo naimportujte s chybami a opravte je ve sjednávači.</Text>
          </Stack>
        </Alert>)

  return (
    <FormSection
      wide={true}
      number={previewCallInProgress ? <Spinner size="xs" /> : currentSection?.index}
      sectionTitle={currentSection?.sectionTitle}
    >
      <Grid gap={12}>

        {/* {previewCallInProgress &&
                    <Flex direction={'row'} alignItems='center' gap={8}>
                        <Text sx={{ fontWeight: 'bold' }}>{progressMsg}</Text>
                        <Button colorScheme="red" onClick={() => cancelImportInProgress()}>Zastavit zpracování náhledu</Button>
                    </Flex>
                } */}

        {errors}

        <Box sx={{ display: 'grid', gap: 4 }}>
          <Box sx={{ maxW: '100%', overflow: 'hidden', overflowX: 'auto' }}>
            <Table cellPadding="0" cellSpacing="0">
              <Thead>
                <TableRow>
                  <TableHeader>
                    <p>Číslo leasingové smlouvy</p>
                  </TableHeader>

                  <TableHeader>
                    <p>VIN</p>
                  </TableHeader>

                  <TableHeader>
                    <p>Vozidlo</p>
                  </TableHeader>

                  <TableHeader >
                    <p>Pojistník</p>
                  </TableHeader>

                  <TableHeader>
                    <p>Chyba</p>
                  </TableHeader>
                </TableRow>
              </Thead>

              <Tbody>
                {((previewRows?.length ?? 0) > 0) &&
                                    previewRows.map((row) => {
                                      return <ImportPreviewRow
                                        key={`${row.leasingContractNumber}_${row.vin}`}
                                        item={row} />
                                    })}
              </Tbody>
            </Table>
          </Box>

        </Box>

        {(showCancelButton || showImportButton || finalImportInProgress) &&
                    <>
                      {errors}


                      <Flex gap={4} justifyContent='center'>
                        {showCancelButton && !finalImportInProgress &&
                                <Button colorScheme="red" onClick={() => cancelImport()}>Zrušit import</Button>
                        }

                        {showImportButton &&
                                <Button
                                  // loadingText='Importuji...'
                                  loadingText={finalProgressMsg}
                                  onClick={() => {
                                    finishImport()
                                      .then((result) => {
                                        if (result)
                                          navigate(`/Poleas/Imports?importId=${importId}&pageSize=0&showAllItems=true`)
                                      })
                                  }}
                                  isLoading={finalImportInProgress}
                                >
                                  Importovat nabídky
                                </Button>
                        }
                      </Flex>

                    </>
        }
      </Grid>
    </FormSection>
  )
}